/**
 * @file 组件初始化入口
 */

import TModal from './modal.vue'
import TConfirm from './confirm'

TModal.install = Vue => {
  Vue.component(TModal.name, TModal)
}
TConfirm.install = Vue => {
  Vue.prototype.$Confirm = TConfirm
  Vue.Confirm = TConfirm
}

export {
  TModal,
  TConfirm
}



// WEBPACK FOOTER //
// ./src/module/modal/index.js